function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import styled from '@emotion/styled';
var StyledBox = styled(Box, {
    shouldForwardProp: function(prop) {
        return prop !== 'center' && prop !== 'height';
    }
})(function(param) {
    var center = param.center, height = param.height;
    return _object_spread({}, center && {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: height !== null && height !== void 0 ? height : '100vh',
        minHeight: height ? undefined : 400
    });
});
export var Preloader = function(param) {
    var center = param.center, height = param.height, sx = param.sx;
    return /*#__PURE__*/ _jsx(StyledBox, {
        center: center,
        height: height,
        className: "c-preloader",
        sx: _object_spread({}, sx),
        children: /*#__PURE__*/ _jsx(CircularProgress, {
            "aria-label": "Loading screen",
            variant: "indeterminate"
        })
    });
};
Preloader.defaultProps = {
    center: false
};
